export default __webpack_public_path__ + "static/media/ultrasonic.644f713b.svg";